import { memoize } from 'lodash'
import { stateCodeToName } from '../../../../../util/states'

// Form
export const INTERESTED_PARTY_FORM_TYPE = 'INTERESTED_PARTY'
export const INDIVIDUAL_FORM_TYPE = 'INDIVIDUAL'

export const FORM_NAME = 'new_entity_form'

export const FIELD_ENTITY_NAME = 'entityNameText'
export const FIELD_INDIVIDUAL_NAME = 'nameText'
export const FORM_TITLE_FIELDS = {
  [INTERESTED_PARTY_FORM_TYPE]: FIELD_ENTITY_NAME,
  [INDIVIDUAL_FORM_TYPE]: FIELD_INDIVIDUAL_NAME,
}
export const MAX_SUBENTITIES = 3
export const INTERESTED_PARTY_LABEL = 'Interested Party'
export const INDIVIDUAL_LABEL = 'Individual'
export const FORM_TITLE_LABELS = {
  [INTERESTED_PARTY_FORM_TYPE]: INTERESTED_PARTY_LABEL,
  [INDIVIDUAL_FORM_TYPE]: INDIVIDUAL_LABEL,
}

export const HIDDEN_FIELD_NAME = 'hidden'

// Entity Constants
export const CORPORATION = 'CORPORATION'
export const GENERAL_PARTNERSHIP = 'GENERAL_PARTNERSHIP'
export const LLC = 'LLC'
export const LTD_LIABILITY_PARTNERSHIP = 'LTD_LIABILITY_PARTNERSHIP'
export const LIMITED_PARTNERSHIP = 'LIMITED_PARTNERSHIP'
export const SERIES_LLC = 'SERIES_LLC'

// States
const memoizedStates = memoize(stateCodeToName) // To avoid multiple function call
const getStateOptions = () => {
  const statesCodes = memoizedStates()
  const statesOptions = []
  let i = 0
  for (const key in statesCodes) {
    statesOptions[i++] = { key, value: key, text: statesCodes[key] }
  }
  return statesOptions
}

export const STATE_OPTIONS = [
  { key: 'default', value: '', text: 'Select' },
  ...getStateOptions(),
]

export const ENTITY_TYPE_OPTIONS = [
  { text: 'Select', value: '' },
  { text: 'Corporation', value: 'CORPORATION' },
  { text: 'General Partnership', value: 'GENERAL_PARTNERSHIP' },
  { text: 'Limited Liability Company', value: 'LLC' },
  {
    text: 'Limited Liability Limited Partnership',
    value: 'LTD_LIABILITY_PARTNERSHIP',
  },
  { text: 'Limited Partnership', value: 'LIMITED_PARTNERSHIP' },
  {
    text: 'Series Limited Liability Corp',
    value: 'SERIES_LLC',
  },
]

const ENTITY_CORP_SIGNOR_TITLE_OPTIONS = [
  {
    text: 'President',
    value: 'PRESIDENT',
  },
  {
    text: 'Vice President',
    value: 'VICE_PRESIDENT',
  },
  {
    text: 'Treasurer',
    value: 'TREASURER',
  },
  {
    text: 'Secretary',
    value: 'SECRETARY',
  },
  {
    text: 'CEO',
    value: 'CEO',
  },
  {
    text: 'CFO',
    value: 'CFO',
  },
  {
    text: 'Chief Executive Officer',
    value: 'CHIEF_EXECUTIVE_OFFICER',
  },
  {
    text: 'Authorized Signatory',
    value: 'AUTHORIZED_SIGNATORY',
  },
  {
    text: 'Power of Attorney',
    value: 'POWER_OF_ATTORNEY',
  },
]

const PARTNERSHIP_SIGNOR_TITLE_OPTIONS = [
  {
    text: 'General Partner',
    value: 'GENERAL_PARTNER',
  },
  {
    text: 'Manager',
    value: 'MANAGER',
  },
  {
    text: 'Member',
    value: 'MEMBER',
  },
  {
    text: 'Managing Member',
    value: 'MANAGING_MEMBER',
  },
  ...ENTITY_CORP_SIGNOR_TITLE_OPTIONS,
]

const LLC_SIGNER_TITLE_OPTIONS = [
  { text: 'Manager', value: 'MANAGER' },
  { text: 'Member', value: 'MEMBER' },
  { text: 'Managing Member', value: 'MANAGING_MEMBER' },
  { text: 'Authorized Signatory', value: 'AUTHORIZED_SIGNATORY' },
  { text: 'Power of Attorney', value: 'POWER_OF_ATTORNEY' },
]

export const ENTITY_SIGNOR_TITLE_OPTIONS = {
  [CORPORATION]: [...ENTITY_CORP_SIGNOR_TITLE_OPTIONS],
  [GENERAL_PARTNERSHIP]: [...PARTNERSHIP_SIGNOR_TITLE_OPTIONS],
  [LTD_LIABILITY_PARTNERSHIP]: [...PARTNERSHIP_SIGNOR_TITLE_OPTIONS],
  [LIMITED_PARTNERSHIP]: [...PARTNERSHIP_SIGNOR_TITLE_OPTIONS],
  [LLC]: [...LLC_SIGNER_TITLE_OPTIONS],
  [SERIES_LLC]: [...LLC_SIGNER_TITLE_OPTIONS],
}

export const OHIO_STATE_VALUE = 'OH'
export const OHIO_ENTITIES_ERROR_MSG =
  'For Ohio properties, the entities must be in Ohio.'
